export enum InvestmentType {
  OnceOffInvestment = 1,
  RecurringInvestment = 2
}